(function(){
function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
function initHeaderNavigation(){
  document.querySelectorAll('.volt-site-nav').forEach(function(nav){
    if(nav.getAttribute('data-volt-navigation-ready')==='true')return;
    nav.setAttribute('data-volt-navigation-ready','true');

    var toggle=nav.querySelector('[data-volt-menu-toggle]');
    var menu=nav.querySelector('[data-volt-menu]');
    var dropdowns=Array.prototype.slice.call(nav.querySelectorAll('.volt-site-nav__dropdown'));
    var mobileQuery=window.matchMedia('(max-width: 820px)');

    function syncDropdown(details){
      var summary=details.querySelector(':scope > summary');
      if(summary)summary.setAttribute('aria-expanded',String(details.open));
    }

    function closeDropdowns(except){
      dropdowns.forEach(function(details){
        if(details===except)return;
        details.open=false;
        syncDropdown(details);
      });
    }

    function setMobileMenu(open){
      if(!toggle||!menu)return;
      closeDropdowns();
      nav.classList.toggle('is-menu-open',open);
      toggle.setAttribute('aria-expanded',String(open));
      toggle.setAttribute('aria-label',open?'Close menu':'Open menu');
    }

    dropdowns.forEach(function(details){
      var summary=details.querySelector(':scope > summary');
      syncDropdown(details);
      if(summary){
        summary.addEventListener('click',function(){
          if(!details.open)closeDropdowns(details);
        });
      }
      details.addEventListener('toggle',function(){
        if(details.open)closeDropdowns(details);
        syncDropdown(details);
      });
    });

    if(toggle){
      toggle.addEventListener('click',function(){
        setMobileMenu(toggle.getAttribute('aria-expanded')!=='true');
      });
    }

    nav.addEventListener('click',function(event){
      var target=event.target;
      if(!target||!target.closest)return;
      var link=target.closest('a[href]');
      if(link&&mobileQuery.matches)setMobileMenu(false);
    });

    document.addEventListener('click',function(event){
      if(event.target instanceof Node&&nav.contains(event.target))return;
      closeDropdowns();
      if(mobileQuery.matches)setMobileMenu(false);
    });

    document.addEventListener('keydown',function(event){
      if(event.key!=='Escape')return;
      closeDropdowns();
      if(mobileQuery.matches&&nav.classList.contains('is-menu-open')){
        setMobileMenu(false);
        if(toggle)toggle.focus();
      }
    });

    function resetNavigation(){
      closeDropdowns();
      nav.classList.remove('is-menu-open');
      if(toggle){
        toggle.setAttribute('aria-expanded','false');
        toggle.setAttribute('aria-label','Open menu');
      }
    }

    if(mobileQuery.addEventListener)mobileQuery.addEventListener('change',resetNavigation);
    else if(mobileQuery.addListener)mobileQuery.addListener(resetNavigation);

    var resizeTimer;
    window.addEventListener('resize',function(){
      window.clearTimeout(resizeTimer);
      resizeTimer=window.setTimeout(resetNavigation,100);
    },{passive:true});
  });
}
function initHeroSlider(){document.querySelectorAll('[data-volt-hero-slider]').forEach(function(slider){var slides=Array.prototype.slice.call(slider.querySelectorAll('[data-volt-hero-slide]'));var dots=Array.prototype.slice.call(slider.querySelectorAll('[data-volt-hero-dot]'));var prev=slider.querySelector('[data-volt-hero-prev]');var next=slider.querySelector('[data-volt-hero-next]');if(slides.length<2)return;var index=0;var timer=null;function syncVideos(){slides.forEach(function(slide,i){var video=slide.querySelector('video');if(!video)return;video.muted=true;video.playsInline=true;if(i===index){var p=video.play();if(p&&p.catch)p.catch(function(){});}else{video.pause();}});}function go(nextIndex){index=(nextIndex+slides.length)%slides.length;slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===index);slide.setAttribute('aria-hidden',String(i!==index));});dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index);dot.setAttribute('aria-pressed',String(i===index));});syncVideos();}function restart(){if(timer)window.clearInterval(timer);timer=window.setInterval(function(){go(index+1);},7000);}if(prev)prev.addEventListener('click',function(event){event.preventDefault();go(index-1);restart();});if(next)next.addEventListener('click',function(event){event.preventDefault();go(index+1);restart();});dots.forEach(function(dot){dot.addEventListener('click',function(event){event.preventDefault();go(Number(dot.getAttribute('data-volt-hero-dot'))||0);restart();});});go(0);restart();});}
ready(function(){initHeaderNavigation();document.querySelectorAll('[data-volt-faq-button]').forEach(function(button){button.addEventListener('click',function(){var a=document.getElementById(button.getAttribute('aria-controls'));if(!a)return;var e=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!e));a.hidden=e;});});initHeroSlider();});
})();